export const lightHouseType = {
    BLUE: 0,
    GREEN: 1,
    YELLOW: 2,
    RED: 3,
    BLACK: 4
}